<template>
  <div class="panel agresividad-panel">
    <h3>
      Índice de Agresividad del Competidor
      <span class="subtitle">(Últimos 30 Días)</span>
    </h3>
    <p class="description">Ranking de tiendas según la cantidad de cambios de precio realizados.</p>

    <div v-if="agresividad && agresividad.length > 0" class="agresividad-list">
      <div v-for="(item, index) in agresividad" :key="item.tienda" class="agresividad-item">
        <template v-if="item && item.cambios">
          <!-- Header: nombre + total -->
          <div class="item-header">
            <span class="store-name">{{ index + 1 }}. {{ formatStoreName(item.tienda) }}</span>
            <span class="change-count">{{ item.cambios.total }} cambios</span>
          </div>

          <!-- Barra full-width con segmentos proporcionales al ITEM -->
          <div class="bar-container">
            <div
              class="bar subidas"
              :style="{ width: getSegmentWidth(item.cambios, 'subidas') }"
              :title="`${item.cambios.subidas} subidas`"
            >
              <span v-if="item.cambios.subidas > 0">{{ item.cambios.subidas }}</span>
            </div>
            <div
              class="bar bajadas"
              :style="{ width: getSegmentWidth(item.cambios, 'bajadas') }"
              :title="`${item.cambios.bajadas} bajadas`"
            >
              <span v-if="item.cambios.bajadas > 0">{{ item.cambios.bajadas }}</span>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div v-else class="no-data-message">
      Calculando datos o sin cambios registrados...
    </div>

    <div class="legend">
      <div class="legend-item"><span class="color-box subidas"></span> Subidas de Precio</div>
      <div class="legend-item"><span class="color-box bajadas"></span> Bajadas de Precio</div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  agresividad: Array
});

const getSegmentWidth = (cambios, type) => {
  if (!cambios || !cambios.total || cambios.total === 0) {
    return '0%';
  }
  const value = cambios[type] || 0;
  const percentage = (value / cambios.total) * 100;
  return `${percentage}%`;
};

const formatStoreName = (name) => {
  if (!name) return '';
  const cleanedName = String(name).replace(/^\d+\.?\s*/, '');
  return cleanedName.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
};
</script>

<style scoped>
.agresividad-panel {
  /* hereda .panel */
}
.subtitle {
  font-size: 10.5px;
  color: var(--color-text-faint);
  font-weight: 500;
  font-family: var(--font-mono);
  letter-spacing: 0.05em;
  margin-left: 8px;
}
.description {
  font-size: 11.5px;
  color: var(--color-text-muted);
  margin: -4px 0 14px;
  font-family: 'Inter', sans-serif;
}

/* ============ LISTA ============ */
.agresividad-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.agresividad-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

/* ============ HEADER ============ */
.item-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 0 2px;
}
.store-name {
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 13px;
  color: var(--color-text);
}
.change-count {
  font-family: var(--font-mono);
  font-size: 11px;
  color: var(--color-text-muted);
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.03em;
}

/* ============ BARRA full-width ============ */
.bar-container {
  display: flex;
  height: 32px;
  width: 100%;
  background: var(--color-surface-2);
  border: 1px solid var(--color-border);
  border-radius: 3px;
  overflow: hidden;
}
.bar {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-mono);
  font-size: 13px;
  font-weight: 700;
  color: white;
  min-width: 0;
  overflow: hidden;
  transition: width 0.3s ease;
  letter-spacing: 0.02em;
}
.bar.subidas {
  background: var(--color-danger);
}
.bar.bajadas {
  background: var(--color-success);
}

/* ============ NO DATA + LEGEND ============ */
.no-data-message {
  padding: 16px;
  text-align: center;
  color: var(--color-text-muted);
  font-size: 12px;
  font-style: italic;
  background: var(--color-surface-2);
  border: 1px dashed var(--color-border-strong);
  border-radius: 2px;
}
.legend {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid var(--color-border);
  font-family: var(--font-mono);
  font-size: 10.5px;
  color: var(--color-text-muted);
  letter-spacing: 0.05em;
}
.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
}
.color-box {
  width: 12px;
  height: 12px;
  border-radius: 2px;
  display: inline-block;
}
.color-box.subidas { background: var(--color-danger); }
.color-box.bajadas { background: var(--color-success); }
</style>